/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter";
import {searchObjectInterpretation} from "./searchObjects"



export function fillSearchObjectInterpretation(){
    searchObjectInterpretation.categories = [];
    searchObjectInterpretation.keywords = [];

    const checkbox = document.getElementById("categoryInterpretation");
    if(checkbox.checked || checkbox.indeterminate){
        searchObjectInterpretation.categories.push(checkbox.value);
    }

    const anyButton = document.getElementById("buttonInterpretationAny");
    if(anyButton.classList.contains("chosen")){
        searchObjectInterpretation.any = true;
    }

    const allButton = document.getElementById("buttonInterpretationAll");
    if(allButton.classList.contains("chosen")){
        searchObjectInterpretation.any = false;
    }
    
    const buttonCombination = document.getElementById("buttonInterpretationCombination");
    if(buttonCombination.classList.contains('selected')){
        searchObjectInterpretation.keywords.push(buttonCombination.value)
    }
    
    const buttonEffectiveFieldTheory = document.getElementById("buttonInterpretationEffectiveFieldTheory");
    if(buttonEffectiveFieldTheory.classList.contains('selected')){
        searchObjectInterpretation.keywords.push(buttonEffectiveFieldTheory.value)
    }
    
    const buttonGeneratorandsimulationtuning = document.getElementById("buttonInterpretationGeneratorandsimulationtuning");
    if(buttonGeneratorandsimulationtuning.classList.contains('selected')){
        searchObjectInterpretation.keywords.push(buttonGeneratorandsimulationtuning.value)
    }
    
    const buttonSimplifiedModelSpectrum = document.getElementById("buttonInterpretationSimplifiedModelSpectrum");
    if(buttonSimplifiedModelSpectrum.classList.contains('selected')){
        searchObjectInterpretation.keywords.push(buttonSimplifiedModelSpectrum.value)
    }
    
    const buttonStandardModelFitsincPDFs = document.getElementById("buttonInterpretationStandardModelFitsincPDFs");
    if(buttonStandardModelFitsincPDFs.classList.contains('selected')){
        searchObjectInterpretation.keywords.push(buttonStandardModelFitsincPDFs.value)
    }
    
    getAllFiltered()

}